import { FileKind } from "../../../define/FileKind";
import { BaseLocalListData } from "../base/BaseLocalListData";

/** 数据 */
export class ShipData {
    /** id */
    id: string = '';
    /** 库存 */
    store: number = 0;
    /** 拥有 */
    ownCount: number = 0;
    /** 当前单价 */
    price: number = 0;
}

export default class ShipDataList extends BaseLocalListData {
    lists = new Map<string, ShipData>();
   
    protected localKey: string = FileKind.SaveLocalDataKey.SHIP_DATA;

    /** 最后一次的刷新时间 */
    lastRefreshTime: number = 0;

    createItem(key: string): ShipData {
        return this.createItemT<ShipData>(ShipData, key);
    }
   
}
